
import { IAccountUnderlyingViewState } from './state';
import { createReducer, on, State, Action } from '@ngrx/store';
import {
  onNgrxForms, onNgrxFormsAction, SetValueAction
} from 'ngrx-forms';
import { ResponseAction } from './actions';
import { AccountUnderlyingModel } from '../../../../model/account-underlying.model';

export const state: IAccountUnderlyingViewState = {
  model: null
};

const reducer = createReducer(state,
  onNgrxForms(),
  onNgrxFormsAction(SetValueAction, (state, action) => {
    return state;
  }),
  on(ResponseAction, (state, { payload }) => {
    return {
      ...state,
      model: payload
    };
  })
);

export function accountUnderlyingViewReducer(state: any | undefined, action: Action) {
  return reducer(state, action);
}
